import service from './http'

/* var instance = axios.create();
if(localStorage.getItem('user')) {
  instance.defaults.headers.common['Authorization'] = 'Bearer ' +
}*/
// axios.defaults.baseURL = Global.host;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
//
//

export default {
  localLogin(data) {
    return service.post('/wms4j/member/login.do', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js